export default __webpack_public_path__ + "static/media/typing.a59afb88.png";